// Библиотеки Materialize для работы с боковой панелью навигации
// TODO: Создать альтертанивый скрипт работы вместо кучи библиотек или вырезать только sideNav
require('materialize-css/js/jquery.easing.1.4');
require('materialize-css/js/velocity.min');
require('materialize-css/js/hammer.min');
require('materialize-css/js/jquery.hammer');
require('materialize-css/js/global');
require('materialize-css/js/sideNav');

// Библиотека Materialize для работы с всплывающими подсказками
// TODO: Заменить на подсказки Bootstrap
require('materialize-css/js/tooltip');

// Библиотека Materialize для работы с прокручиванием страницы по якорям
require('materialize-css/js/scrollspy');

// Самоисполняемя функция (запускается сразу после обнаружения браузером)
// TODO: Проверить, что надо, а что нет
(function ($, document) {

    // Функция проверки того загружен ли DOM (эквивалентно записи $(document).ready())
    $(function () {

        $('.tooltiped').tooltip({delay: 50});
        $('.scrollspy').scrollSpy();
        $('.sidebar-trigger').sideNav();

    });

})(jQuery, document);